export type TextMeasurer = (candidate: string) => number;

export const createTextMeasurer = (element: HTMLElement): TextMeasurer | undefined => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) return undefined;

  const { font, letterSpacing } = getComputedStyle(element);
  if (!font) return undefined;

  context.font = font;

  const letterSpacingPx = Number.parseFloat(letterSpacing);
  const letterSpacingValue = Number.isFinite(letterSpacingPx) ? letterSpacingPx : 0;

  return (candidate: string) => {
    const metrics = context.measureText(candidate);
    const spacing = letterSpacingValue * Math.max(0, candidate.length - 1);
    return metrics.width + spacing;
  };
};

export const createTextWidthMeasurer = (element: HTMLElement): TextMeasurer => {
  const measurer = createTextMeasurer(element);

  return (candidate: string) => {
    if (measurer) {
      const measured = measurer(candidate);
      if (Number.isFinite(measured)) return measured;
    }

    element.textContent = candidate;
    return element.scrollWidth;
  };
};
